import React from 'react';
import { Modal } from '@codametrix/ui-components';

type ResolverModalProps = {
  validationErrors: CQA.ValidationErrorDto[];
  onClose: () => void;
};

const WARNING = 'WARNING';

function isWarning(dto: CQA.ValidationErrorDto): boolean {
  const s = (dto.severity ?? '').toUpperCase();
  return s === WARNING;
}

/** Resolver returns severities like CRITICAL / ERROR; only WARNING is non-blocking in this UI. */
function isError(dto: CQA.ValidationErrorDto): boolean {
  return !isWarning(dto);
}

/**
 * Modal for resolver validation errors, same format and styling as the Vitalware
 * modal (code-bench.vw-modal) but without comment or override controls.
 */
const GradeBenchResolverModal: React.FC<ResolverModalProps> = ({
  validationErrors,
  onClose
}) => {
  const errors = validationErrors.filter(isError);
  const warnings = validationErrors.filter(isWarning);

  return (
    <div className="top-level-modal vw-modal">
      <Modal
        closable={true}
        maximize={false}
        onClose={onClose}
        title="Can you check these items before submission?">
        <h4 className="vw-title">Validation issues</h4>
        <p className="vw-subtitle">
          Please fix the following validation issues before submitting.
        </p>
        <div className="vw-issues-box">
          {errors.length > 0 && (
            <div className="vw-issues-section vw-error-issues">
              <h3 className="vw-issues-title vw-issues-error">ERRORS</h3>
              {errors.map((dto, idx) => (
                <li className="vw-issues-text" key={`error-${idx}-${dto.message ?? idx}`}>
                  {dto.message ?? ''}
                </li>
              ))}
            </div>
          )}
          {warnings.length > 0 && (
            <div className="vw-issues-section vw-warning-issues">
              <h3 className="vw-issues-title vw-issues-warning">WARNINGS</h3>
              {warnings.map((dto, idx) => (
                <li className="vw-issues-text" key={`warning-${idx}-${dto.message ?? idx}`}>
                  {dto.message ?? ''}
                </li>
              ))}
            </div>
          )}
        </div>
        <div className="vw-buttons-group">
          <button
            type="button"
            onClick={onClose}
            className="chakra-secondary-button override-close-button">
            I&apos;ll make changes
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default GradeBenchResolverModal;
